import { connectedStore } from '../../store';
import selectors from '../selectors';
import mapMetaTranslations from '../helpers/map-meta-translations';

const getMetaTranslations = (translationKey) => {
  const store = connectedStore.get();
  const state = store.getState();

  const metaTranslations = selectors.getMetaTranslations(state);

  return mapMetaTranslations(metaTranslations, translationKey);
};

export default getMetaTranslations;
